import { useState, useEffect } from 'react';
import { debounce } from 'throttle-debounce';

/**
 * Hook that triggers when the user has moved the mouse to an Y coordinate within the viewport threshold.
 * @param {number} threshold - Value in pixels from the top of the viewport.
 */

export const useIntentToLeave = (threshold = 5) => {
    const [intent, setIntent] = useState(false);

    useEffect(() => {
        const handleMouseMove = debounce(200, (e: MouseEvent) => {
            const { clientY } = e;

            if (clientY < threshold) {
                setIntent(true);
            } else {
                setIntent(false);
            }
        });

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, [threshold]);

    return intent;
};
